import api from '@/composables/useApi';

const API_BASE = process.env.VUE_APP_API_URL || 'http://localhost:8000';

function resolveUrl(path) {
    if (!path) return null;
    // Already a full URL (blob: or http)
    if (path.startsWith('http') || path.startsWith('blob:')) return path;
    // Relative storage path — prepend API base
    return API_BASE + path;
}

export const state = {
    settings: {
        system_name: 'TMS',
        logo: null,
        login_logo: null,
        login_background_video: null
    }
};

export const getters = {
    settings: state => state.settings,
    system_name: state => state.settings.system_name,
    logo: state => resolveUrl(state.settings.logo),
    login_logo: state => resolveUrl(state.settings.login_logo),
    login_background_video: state => resolveUrl(state.settings.login_background_video),
};

export const mutations = {
    SET_SETTINGS(state, settings) {
        state.settings = { ...state.settings, ...settings };
    }
};

export const actions = {
    async fetchSettings({ commit }) {
        try {
            const response = await api.get('/api/system-settings');
            // If response.data is array of values, or object. Controller returns {key: val, ...}
            // Logic in controller: SystemSetting::all()->pluck('value', 'key');
            // So it returns object { system_name: '...', logo: '...' }
            commit('SET_SETTINGS', response.data);
            return response;
        } catch (error) {
            console.error('Error fetching system settings:', error);
        }
    },
    async updateSettings({ commit }, formData) {
        try {
            const response = await api.post('/api/system-settings', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            // Controller returns { message: '...', settings: { ... } }
            commit('SET_SETTINGS', response.data.settings);
            return response;
        } catch (error) {
            console.error('Error updating system settings:', error);
            throw error;
        }
    }
};
